import React, { useState, useEffect } from "react";
import Header from "../../../componentes/header/header";
import FinalComponent from "../../../componentes/EndPage/Final";
import JsonData from "./Artigos.json";  
import translations from "./traducao.json";  

function Artigos() {
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("siteLanguage") || 'pt');

    const handleLanguageChange = (newLang) => {
        setCurrentLanguage(newLang);
        localStorage.setItem("siteLanguage", newLang); 
        window.location.reload(); 
    };

    useEffect(() => {
        const browserLang = navigator.language.split("-")[0]; 
        const supportedLanguages = ['pt', 'en', 'es']; 
        const savedLang = localStorage.getItem("siteLanguage");

        if (!savedLang) {
            if (supportedLanguages.includes(browserLang)) {
                setCurrentLanguage(browserLang); 
                localStorage.setItem("siteLanguage", browserLang); 
            } else {
                setCurrentLanguage('pt'); 
                localStorage.setItem("siteLanguage", 'pt'); 
            }
        }
    }, []); 

    const translation = translations[currentLanguage];

    const currentJsonData = JsonData[currentLanguage];  

    return (
        <>
            <Header handleLanguageChange={handleLanguageChange} />
            <h1
            className="
                text-[4vh] text-[#B040B1] inline-block relative font-bold
                mt-[0vh] mb-[2vh] 
                max-[480px]:mt-[16vh]
                max-[768px]:mt-[14vh]
                max-[1024px]:mt-[10vh]
                max-[1440px]:mt-[8vh]
            "
            >
            {translation.artigosTitle}
            <span className="absolute bottom-[-8px] left-[-30px] w-[120%] h-[5px] bg-gradient-to-r from-[#6A0DAD] to-[#FF66B2] rounded-[2px]"></span>
            </h1>


            <div>
                {currentJsonData.map((item, index) => (
                    <div key={index} className="bg-[#FAFAFA] p-5 m-5 mx-auto text-left rounded-[10px] shadow-[0px_4px_10px_rgba(0,0,0,0.2)] border-l-[5px] border-l-[#6A0DAD] max-w-[60%] mb-[3%] w-[90%] z-0">
                        <h2 className="text-[1.5em] font-bold text-[#6A0DAD] mb-[10px]">{item.name}</h2>
                        <p className="mb-4">{translation.autores}: {item.autores}</p>
                        <p className="text-base text-[#333] leading-[1.5] mb-4">{item.conteudo}</p>
                        <a href={item.linker} className="inline-block mt-[10px] text-[#B040B1] no-underline font-bold hover:underline" target="_blank" rel="noopener noreferrer">
                            {item.Acesse}
                        </a>
                    </div>
                ))}
            </div>
            
            <FinalComponent />
        </>
    );
}

export default Artigos;
